import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  Award,
  CalendarDays,
  LockKeyhole,
  Sparkles,
  UserRound,
} from "lucide-react";

export const ChiefGuestPage = () => (
  <main className="min-h-screen bg-background text-foreground">
    <section className="relative overflow-hidden border-b border-border/40 py-16 md:py-24">
      <div className="absolute inset-0 bg-gradient-to-b from-cyan-500/10 via-transparent to-transparent pointer-events-none" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-500/10 border border-cyan-500/30 text-cyan-400 text-xs font-mono uppercase tracking-wider">
            Kian Technologies • Grand Finale
          </span>
          <h1 className="mt-5 text-4xl sm:text-5xl font-extrabold tracking-tight leading-tight">
            Meet Our{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-emerald-400">
              Chief Guest
            </span>
          </h1>
          <p className="mt-5 text-base sm:text-lg text-muted-foreground leading-relaxed">
            The final day of the Masterclass will include a special certificate
            ceremony with a distinguished Chief Guest.
          </p>
        </div>
      </div>
    </section>

    <section className="py-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-3xl bg-card border border-border shadow-xl overflow-hidden">
          <div className="p-8 sm:p-12 text-center">
            <div className="mx-auto w-28 h-28 rounded-full bg-cyan-500/10 border border-cyan-500/30 flex items-center justify-center shadow-lg">
              <LockKeyhole className="w-10 h-10 text-cyan-400" />
            </div>

            <span className="inline-flex items-center gap-2 mt-7 px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-xs font-mono">
              <Sparkles className="w-3.5 h-3.5" />
              Special Guest • To Be Revealed
            </span>

            <h2 className="mt-5 text-3xl sm:text-4xl font-bold">
              Our Chief Guest Will Be Revealed Soon
            </h2>

            <p className="mt-4 text-sm sm:text-base text-muted-foreground leading-relaxed max-w-xl mx-auto">
              We are preparing a special guest appearance for the Masterclass
              certificate ceremony. The identity will be officially announced
              closer to the event.
            </p>

            <div className="mt-8 grid sm:grid-cols-3 gap-3 text-left">
              <div className="p-4 rounded-xl bg-muted/40 border border-border">
                <Award className="w-5 h-5 text-emerald-400" />
                <p className="mt-3 text-sm font-semibold">Certificate Ceremony</p>
                <p className="mt-1 text-xs text-muted-foreground">
                  A special closing ceremony for participating students.
                </p>
              </div>
              <div className="p-4 rounded-xl bg-muted/40 border border-border">
                <UserRound className="w-5 h-5 text-cyan-400" />
                <p className="mt-3 text-sm font-semibold">Distinguished Guest</p>
                <p className="mt-1 text-xs text-muted-foreground">
                  Guest details will be announced officially.
                </p>
              </div>
              <div className="p-4 rounded-xl bg-muted/40 border border-border">
                <CalendarDays className="w-5 h-5 text-emerald-400" />
                <p className="mt-3 text-sm font-semibold">Final Day</p>
                <p className="mt-1 text-xs text-muted-foreground">
                  The reveal will be shared closer to the ceremony.
                </p>
              </div>
            </div>
          </div>
        </div>

        <p className="text-center text-xs text-muted-foreground mt-6 font-mono">
          Please follow Kian Technologies' official announcements for the reveal.
        </p>
      </div>
    </section>

    <section className="py-14 border-t border-border/40 text-center bg-gradient-to-t from-cyan-950/20 to-transparent">
      <div className="max-w-2xl mx-auto px-4">
        <h2 className="text-2xl font-bold">Be Part of the Grand Finale</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Join the Masterclass and complete the journey with your fellow learners.
        </p>
        <Link
          to="/register"
          className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white font-mono text-sm transition-colors"
        >
          Apply for the Masterclass
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  </main>
);
